'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActionBuild = function ActionBuild(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z' })
  );
};
ActionBuild = (0, _pure2.default)(ActionBuild);
ActionBuild.displayName = 'ActionBuild';
ActionBuild.muiName = 'SvgIcon';

exports.default = ActionBuild;


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/svg-icons/action/build.js
 ** module id = 1045
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/material-ui/svg-icons/action/build.js
 ** module id = 1045
 ** module chunks = 1
 **/